<template>
  <Loading v-if="loading" />
  <Modal @close="closeModal">
    <div class="reserveLocker">
      <div class="reserveLocker__header">
        <span class="title">{{ $t('reserveLocker') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="closeModal"
        />
      </div>
      <div class="reserveLocker__body">
        <FormKit
          type="form"
          id="createReservation-form"
          v-model="formData"
          :actions="false"
          :config="validationRules"
          @submit="submitHandler"
        >
          <div class="reserveLocker__body-kolliID">
            <Input
              type="text"
              name="deliveryId"
              :label="$t('kolliID')"
              validation="required"
              :validationMessages="{
                required: $t('validation.required')
              }"
              @keydown.space="(event) => event.preventDefault()"
            />
            <Input
              v-for="el in kolliID"
              :key="el.id"
              :type="el.type"
              :name="el.name"
              :label="$t(el.label)"
              @keydown.space="(event) => event.preventDefault()"
            />
          </div>
          <Input
            type="tel"
            name="phoneNumber"
            :label="$t('phoneNumber')"
            :validation="[['required'], ['matches', /^\+[0-9]{10,14}$/]]"
            validation-visibility="dirty"
            :validationMessages="{
              matches: $t('validation.phoneNumber'),
              required: $t('validation.required')
            }"
          />
          <Checkbox
            name="is_drug"
            :value="formData.is_drug"
            :title="$t('isDrug')"
            @change="formData.is_drug = !formData.is_drug"
          />
          <div class="block__ssn" v-if="formData.is_drug">
            <label class="label-ssn" for="ssn">
              {{ $t('ssn') }}
            </label>
            <Input v-model="formData.ssn" type="text" name="ssn" />
          </div>
        </FormKit>
      </div>
      <div class="reserveLocker__buttons">
        <Button variant="filled" :title="$t('reserve')" @click="submitForm" />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="closeModal"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import { kolliID } from './configs';
import router from '@/router';
import { DataCreatePharmacyReservation } from '@/store/modules/pharmacy/types';

@Options({
  name: 'ReserveLocker',
  props: ['showModalReserveLocker', 'selectedLockers', 'activePickupBox'],
  emits: ['closeModal'],
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        deliveryId: '',
        additionalDeliveryId1: '',
        additionalDeliveryId2: '',
        phoneNumber: '',
        is_drug: false,
        ssn: ''
      },
      payload: null,
      validationRules: {},
      loading: false,
      kolliID
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('pharmacy', [
      'createReservation',
      'getPickupBoxesByPharmacy'
    ]),
    async submitHandler(data: DataCreatePharmacyReservation) {
      if (this.formData.additionalDeliveryId1 === '') {
        this.dataAdditionalDeliveryIds = [
          this.formData.additionalDeliveryId2.replace(/\s+/g, '').toLowerCase()
        ];
      } else {
        this.dataAdditionalDeliveryIds = [
          this.formData.additionalDeliveryId1.replace(/\s+/g, '').toLowerCase(),
          this.formData.additionalDeliveryId2.replace(/\s+/g, '').toLowerCase()
        ];
      }

      if (typeof this.selectedLockers === 'string') {
        this.payload = {
          ...data,
          deliveryId: this.formData.deliveryId
            .replace(/\s+/g, '')
            .toLowerCase(),
          userId: this.user.id,
          lockerId: this.selectedLockers.split(' '),
          additionalDeliveryIds: this.dataAdditionalDeliveryIds
        };
      } else {
        this.payload = {
          ...data,
          deliveryId: this.formData.deliveryId
            .replace(/\s+/g, '')
            .toLowerCase(),
          userId: this.user.id,
          lockerId: [...this.selectedLockers],
          additionalDeliveryIds: this.dataAdditionalDeliveryIds
        };
      }

      delete this.payload.additionalDeliveryId1;
      delete this.payload.additionalDeliveryId2;

      this.loading = true;
      await this.createReservation({
        data: this.payload,
        boxId: this.activePickupBox.id
      });

      const { id } = this.$route.params;

      router.push({
        name: 'Lockers',
        params: { id, boxId: this.activePickupBox.id }
      });

      await this.getPickupBoxesByPharmacy(id);

      this.$formkit.reset('createReservation-form');
      this.$emit('closeModal');
      this.loading = false;
    },
    submitForm() {
      this.$formkit.submit('createReservation-form');
    },
    closeModal() {
      this.$emit('closeModal');
      this.$formkit.reset('createReservation-form');
    }
  }
})
export default class ReserveLocker extends Vue {}
</script>

<style lang="scss">
.reserveLocker {
  width: 460px;
  height: 100%;
  .reserveLocker__header {
    display: flex;
    justify-content: space-between;
    padding: 24px 24px 0 24px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: 14px;
    }
    img {
      cursor: pointer;
    }
  }
  .reserveLocker__body {
    padding: 0 24px;
    margin-top: 38px;
    margin-bottom: 30px;
    .formkit-form {
      .reserveLocker__body-kolliID {
        display: flex;
        justify-content: space-between;
        height: 78px;
        .formkit-outer {
          margin-bottom: 38px;
          .formkit-wrapper {
            .formkit-inner {
              width: 127px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
      .block__ssn {
        position: relative;
        width: 412px;
        height: 48px;
        margin-top: 24px;
        label {
          position: absolute;
          font-family: 'Ubuntu-Regular';
          top: -6px;
          left: 15px;
          padding: 0 5px;
          background: $white;
          color: $label;
          font-weight: 400;
          font-size: $twelveSize;
          line-height: $fourteenSize;
          z-index: 1;
        }
      }
    }
  }
  .reserveLocker__buttons {
    padding: 24px;
  }
}
</style>
